import { render, staticRenderFns } from "./FeedbackPopover.vue?vue&type=template&id=6ae70725&scoped=true&"
import script from "./FeedbackPopover.vue?vue&type=script&lang=js&"
export * from "./FeedbackPopover.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPopover.vue?vue&type=style&index=0&id=6ae70725&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae70725",
  null
  
)

export default component.exports